// src/redux/authSlice.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Only storing accessToken
  accessToken: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      // Use this for initial login
      const { accessToken } = action.payload;
      state.accessToken = accessToken;
    },
    setAccessToken: (state, action) => {
      // Use this only for token refresh to update the token value
      state.accessToken = action.payload.accessToken;
    },
    logout: (state) => {
      // Clear the token on logout
      state.accessToken = null;
    },
  },
});

// Export all necessary actions
export const { setCredentials, setAccessToken, logout } = authSlice.actions;

export default authSlice.reducer;